<template>
  <b-row align-h="center">
    <b-col lg="8">
      <h2 v-if="title" class="mb-3">
        {{ title }}
      </h2>

      <slot>
        <p v-if="description" class="mb-0">
          {{ description }}
        </p>
      </slot>

      <div class="gallery">
        <div v-for="(photo, index) in photos" :key="`photo${photo.id}`" class="gallery-panel">
          <jb-picture
            :src="`${photo.filename}`"
            sizes="xs:253px sm:240px md:150px lg:210px xl:437px"
            width="437"
            height="437"
            :img-attrs="{class:'img-fluid img-shadow rounded', alt: photo.title, width: 437, height: 437}"
            :data-source="photo.filename"
            @click="previewImgObject(index)"
          />
        </div>
      </div>

      <div v-if="showButton" class="mt-3 mt-lg-2 text-center">
        <b-button
          to="/pred-a-po-pouziti/"
          variant="primary"
          class="mt-3 mt-xl-4"
        >
          Více z naší práce
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { api as viewerApi } from 'v-viewer'
import JbPicture from '~/components/Core/JbPicture/JbPicture'

export default {
  name: 'GalerieSection',
  components: {
    JbPicture
  },
  props: {
    title: {
      type: String,
      default: 'Galerie'
    },
    subtitle: {
      type: String,
      default: 'Prohlédněte si naši práci'
    },
    description: {
      type: String,
      default: undefined
    },
    photos: {
      type: Array,
      default: () => []
    },
    showButton: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: {
      url: 'data-source',
      button: true,
      navbar: true,
      title: false,
      toolbar: false,
      tooltip: true,
      movable: false,
      zoomable: true,
      rotatable: false,
      scalable: false,
      transition: true,
      fullscreen: true,
      keyboard: true,
      inheritedAttributes: ['crossOrigin', 'decoding', 'isMap', 'loading', 'referrerPolicy', 'useMap']
    }
  }),
  computed: {
    sourcePhotos () {
      return this.photos.map(photo => ({ 'data-source': photo.filename }))
    }
  },
  methods: {
    previewImgObject (index) {
      viewerApi({
        options: {
          ...this.options,
          initialViewIndex: index
        },
        images: this.sourcePhotos
      })
    }
  }
}
</script>

<style lang="scss">
@import "~assets/scss/vars/initial";
@import "~assets/scss/partials/viewer";
@import "~assets/scss/sections/galerie-section";
</style>
